<template>
<div id="body">
  <FixedTool />
	<div class="page-content" id="capture">
		<div class="activity-info">
			<div class="content">
				<div class="head">
					<img :src="shareData.head_pic" alt="" />
					<div class="name">
						<div>{{ shareData.nickname }}</div>
						<span>@你，发现好物，想与你一起分享</span>
					</div>
				</div>
				<img :src="shareData.share.share_img" alt="" class="posters" />
				<div class="desc" v-html="shareData.share.content"></div>
			</div>
      <img class="dot" src="../../assets/images/bg11.png" alt="">
      <div class="zhanwei"></div>
		</div>

    <div class="footer">
      <img src="../../assets/images/yuanhu.png" class="yuanhu" alt="">
      <div class="neirong">
        <div class="qrcode-box">
          <div class="qrcode">
            <img
                :src="shareCode"
                alt=""
            />
          </div>
        </div>
        <div class="prompt">
          <p>长按二维码，立即参与</p>
          <p>此二维码已安全认证，可放心扫描</p>
        </div>
      </div>
    </div>
	</div>
	<!-- <div id="poster-page"></div> -->
	<img id="poster-page" :src="shareImg" style="width: 100%;">
  <div v-if="shareImg" style="background:#4267FC;width: 100%;height: 20px;position: relative;top: -10px; "></div>
</div>
</template>

<script>
export default {
	name: 'ActivityShare',
	components: {},
	data() {
		return {
			shareData: {
				share: {},
			},
			shareImg: '',
			shareCode:'',
      windowWidth: 375,
		}
	},
	mounted() {
		var activity_id = this.$route.query.activity_id
		if (!activity_id) {
			activity_id = this.$ajax.get_activity_id()
		}
		var _this = this;
		this.$ajax.get('m/share/share_hb', { id: activity_id }).then((res) => {
			_this.shareData = res
			_this.shareCode = 'http://m.ewm.ccoo.cn/qrimg.ashx?scale=200&codeStr='+res.share.url;
			this.$nextTick(() => {
				this.screenShot()
			})
		})
		document.title = '分享海报';
		this.windowWidth = document.body.scrollWidth;

	},
	methods: {
		screenShot() {
			let _this = this;
			let capture = document.getElementById('capture');

			html2canvas(document.querySelector('#capture'), {
				useCORS: true,
				// width: window.screen.availWidth,
				// height: window.screen.availHeight,
				// windowWidth: document.body.scrollWidth,
				// windowHeight: document.body.scrollHeight,
        windowWidth: capture.offsetWidth,
				windowHeight: capture.offsetHeight,
				x: 0,
				y: window.pageYOffset,
			}).then((canvas) => {

				document.getElementById('poster-page').appendChild(canvas)
        capture.style.display = 'none'

				_this.shareImg = canvas.toDataURL("image/png")
				document.title = '分享海报';
			})
		},
	},
}
</script>

<style lang="less" scoped>
#body{
  background: #4267FC;
  min-height: 100vh;
}
#poster-page {
	width: 100%;
	z-index: 899;
	background-color: #fff;
}
.zhanwei{
  width: 100%;
  height: 60px;
  background: #ffffff;
  margin-top: -5px;
}
.page-content {
	position: absolute;
	z-index: 1;
	width: 100%;
  background: #4267FC;
	.activity-info {
		width: 100%;
    background: linear-gradient(
        180deg,
        #00C2FF 0%,
        #333EDB 100%
    );
    .dot{
      width: 100%;
    }
		box-sizing: border-box;
		padding: 20px 15px 0 15px;
		.content {
			width: 100%;
      background-color: #ffffff;
			background-size: contain;
			box-sizing: border-box;
			padding: 10px 20px;
			.head {
				width: 100%;
				height: 50px;
				display: flex;
				align-items: center;
				img {
					width: 50px;
					height: 50px;
					object-fit: cover;
					margin-right: 10px;
					border-radius: 50%;
				}
				.name {
					div {
						font-size: 15px;
						font-weight: bold;
						color: #333;
					}
					span {
						font-size: 13px;
						color: #666;
						margin-top: 5px;
					}
				}
			}
			.posters {
				width: 100%;
				height: 230px;
				max-height: 40vh;
				object-fit: cover;
				margin-top: 10px;
			}
			.desc {
				::v-deep{
					img{width: 100%;}
				}
				font-size: 13px;
				color: #666;
				margin-top: 5px;
        margin-bottom: 10px;
			}
		}
	}
	.footer {
    overflow: hidden;
		width: 100%;
    background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-sizing: border-box;
		padding-top: 10px;
    position: relative;
    top: -100px;
    .neirong{
      width: 100%;
      background: #4267FC;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      top: -5px;
      .qrcode-box{
        width: 134px;
        height: 134px;
        border-radius: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        top: -60px;
        background-color:#4267FC ;
      }
    }
    .yuanhu{
      width: 100%;
      height: 60px;
    }
		.qrcode {
			width: 104px;
			height: 104px;
			background-color: #fff;
			border: 4px #c7d3ff solid;
			border-radius: 50%;
			box-sizing: border-box;
			padding: 16px;
			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
		.prompt {
			font-size: 14px;
			color: #fff;
			margin-top: -40px;
			p {
				margin-bottom: 5px;
				text-align: center;
			}
		}
	}
}
</style>
